module.exports = __webpack_public_path__ + "static/media/delivery-brown.a742007d.svg";